import { Brain, Heart, Sparkles, CheckCircle2 } from "lucide-react";

const AppPreview = () => {
  return (
    <div className="relative">
      {/* Mockup Container */}
      <div className="bg-gradient-to-br from-primary/10 to-accent/5 rounded-3xl border border-primary/20 p-8 shadow-[var(--shadow-soft)]">
        <div className="space-y-6">
          {/* Header Mockup */}
          <div className="flex items-center justify-between pb-4 border-b border-primary/10">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-primary/20" />
              <div className="space-y-1">
                <div className="w-24 h-3 bg-foreground/20 rounded" />
                <div className="w-16 h-2 bg-foreground/10 rounded" />
              </div>
            </div>
            <Heart className="w-6 h-6 text-primary opacity-60" />
          </div>

          {/* Feature Cards Mockup */}
          <div className="space-y-3">
            {[
              { icon: Brain, label: "Captura rápida", bgClass: "bg-primary/10", textClass: "text-primary" },
              { icon: Sparkles, label: "Processamento IA", bgClass: "bg-accent/10", textClass: "text-accent" },
              { icon: CheckCircle2, label: "Tarefa concluída", bgClass: "bg-primary/10", textClass: "text-primary" },
            ].map((item, idx) => (
              <div
                key={idx}
                className="flex items-center gap-4 bg-card/50 p-4 rounded-xl border border-border/50"
              >
                <div className={`w-10 h-10 rounded-lg ${item.bgClass} flex items-center justify-center`}>
                  <item.icon className={`w-5 h-5 ${item.textClass}`} />
                </div>
                <div className="flex-1 space-y-2">
                  <div className="w-32 h-2 bg-foreground/20 rounded" />
                  <div className="w-48 h-2 bg-foreground/10 rounded" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Glow Effect */}
      <div className="absolute inset-0 bg-gradient-to-t from-primary/5 to-transparent rounded-3xl -z-10 blur-2xl" />
    </div>
  );
};

export default AppPreview;
